import { CoreProvider } from './../../providers/core-service/core-service';
import { Component, Input } from '@angular/core';

import { legendaStati } from './../../constants/constants';
import { AlertController } from 'ionic-angular';

/**
 * Generated class for the CommonHeaderComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */


@Component({
    selector: 'halfday-block',
    templateUrl: 'halfday-block.html'
})
export class HalfDayBlockComponent {

    @Input() halfday: string;
    @Input() halfday_note: string;
    @Input() show_note: boolean;

    showNote: boolean = false;

    constructor(private alertCtrl: AlertController,
        private core: CoreProvider
    ) {

    }

    /**
     * On Press apre la nota della mezza giornata
     */
    openNote() {
        let txt = "Place:<br><b>" + this.halfday + "</b>";

        if (this.halfday_note)
            txt = txt + '<br><br> Notes:<br> ' + this.halfday_note;

        if (legendaStati.indexOf(this.halfday) == -1 && this.core.getLeaveLabel().indexOf(this.halfday) == -1) {

            let alert = this.alertCtrl.create({
                title: txt,
                buttons: ['CLOSE']
            });
            alert.present();
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/halfday-block/halfday-block.ts